module.exports = __webpack_public_path__ + "static/media/2.eaa1804a.jpg";